import React, { FC, useMemo, useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import cardContentStyles from './cardContentStyles';
import ViewMoreCta from '../../viewMoreCTA/ViewMoreCTA';

export interface ICardContentProps {
  features?: string[];
  hasDisclaimer?: boolean;
}

const CardContent: FC<ICardContentProps> = ({ features, hasDisclaimer }) => {
  const styles = cardContentStyles();
  const [viewAllFeatures, setViewAllFeatures] = useState(false);
  const minVisible = hasDisclaimer ? 2 : 4;
  const showCta = features.length > minVisible;
  const visibleFeatures = useMemo(
    () => (viewAllFeatures ? features : features.slice(0, minVisible)),
    [features, viewAllFeatures],
  );

  return (
    <Box className={styles.container} display="flex" flexDirection="column" alignItems="center">
      <ul className={styles.featureList} data-test="stockLite:card:keyFeatures">
        {features &&
          visibleFeatures.map((feature, index) => (
            <li key={index} className={styles.featureItem}>
              <Typography variant="body2">{feature}</Typography>
            </li>
          ))}
      </ul>
      {showCta && (
        <ViewMoreCta
          dataTest="stockLite:card:viewMore"
          opened={viewAllFeatures}
          onClick={() => setViewAllFeatures(prevState => !prevState)}
        />
      )}
    </Box>
  );
};

export default CardContent;
